import apiClient from '../utils/apiClient';

export const getMyUploads = async () => {
    const response = await apiClient.get('/uploads/me');
    return response.data;
};

export const uploadFile = async (file, onUploadProgress) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post('/uploads', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress,
    });
    return response.data;
};

export const toggleShareFile = async (id, isShared) => {
    const response = await apiClient.patch(`/uploads/${id}/share`, { isShared });
    return response.data;
};

export const deleteUploadedFile = async (id) => {
    const response = await apiClient.delete(`/uploads/${id}`);
    return response.data;
};

export const cleanupOldFiles = async () => {
    const response = await apiClient.delete('/uploads/cleanup/old');
    return response.data;
};

export const getPublicShareUrl = (shareToken) => {
    const base = apiClient.defaults.baseURL || '/api';
    const origin = window.location.origin;
    return `${origin}${base}/public/uploads/${shareToken}`;
};
